import { useMutation, useQueryClient } from '@tanstack/react-query';

import { migrateVesselData } from '../../../../common/api/clients/vessel.api';
import { queries } from '../../../../common/api/queryKeys/queries';

export const useVesselDataMigration = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: migrateVesselData,
        onSuccess: () => queryClient.invalidateQueries({ queryKey: queries.vessels._def }),
    });
};
